//@flow
import React, {useState} from 'react';
import {
  makeStyles,
  Typography,
  MenuItem,
  Grid,
  IconButton,
} from '@material-ui/core';
import CustomSelect from '../../../../../../elements/CustomSelect/CustomSelect';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {colors} from '../../../../../../assets/styles/colors';
import {Delete} from '@material-ui/icons';
import {useStoreCurrency} from '../../../../../currency/utils';
import {CURRENCY_MAP_NAME} from '../../../../../currency/constants';

import type {FilterRowProps} from '.';
import {useDebounceEffect} from '../../../../../../utils/react';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.5rem',
    borderRadius: '1rem',
    background: colors.grey200,
  },
}));

const operators = [
  {
    value: 'gt',
    label: 'Más de',
  },
  {
    value: 'lt',
    label: 'Menos de',
  },
  {
    value: 'eq',
    label: 'Igual a',
  },
];

export default function OrderAmountFilter(props: FilterRowProps) {
  const {conditions = {}, onChange, onDelete} = props;

  const classes = useStyles();
  const currency = useStoreCurrency();

  const {amount, operator} = conditions;

  const [priceAmount, setPriceAmount] = useState(amount ?? '');
  const [priceOperator, setPriceOperator] = useState(operator ?? 'gt');

  const currencyName = CURRENCY_MAP_NAME[currency?.code ?? 'PEN']?.name;

  useDebounceEffect(
    () => {
      if (!onChange) return;

      onChange({
        amount: Number(priceAmount),
        operator: priceOperator,
      });
    },
    500,
    [priceAmount, priceOperator]
  );

  return (
    <Grid container className={classes.root} spacing={1} alignItems="center">
      <Grid item xs={3}>
        <CustomSelect
          fullWidth
          className={classes.select}
          value={priceOperator}
          onChange={e => setPriceOperator(e.target.value)}
        >
          {operators.map(el => (
            <MenuItem
              key={'text-color-' + el.label}
              value={el.value}
              className={classes.itemSelectFontColor}
            >
              <Typography>{el.label}</Typography>
            </MenuItem>
          ))}
        </CustomSelect>
      </Grid>
      <Grid item xs={3}>
        <CustomTextField
          type="number"
          fullWidth
          placeholder="1000"
          value={priceAmount}
          onChange={e => setPriceAmount(e.target.value)}
        />
      </Grid>

      <Grid item xs={5}>
        <Typography>{currencyName}</Typography>
      </Grid>
      <Grid item xs={1}>
        <IconButton onClick={onDelete}>
          <Delete />
        </IconButton>
      </Grid>
    </Grid>
  );
}
